import React, { Fragment, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import OptionsBox from "form/components/select-field-combo/options-box";
import { xs, sm, md } from "form/components/select-field-combo/modal-styles";
import selectTop from "assets/img/select-top.png";
import selectBottom from "assets/img/select-bottom.png";
import {
  contains,
  isEmpty,
  length,
  find,
  propEq,
  join,
  filter,
  map,
  isNil,
  is,
  includes,
  defaultTo,
} from "ramda";
import ReactHtmlParser from "react-html-parser";
import { exists, translate } from "application/functions";

const SelectFieldComboInput = (props) => {
  const {
    name,
    isMulti,
    options,
    onChange,
    onChangeMulti,
    size,
    locale,
    show,
    value,
    field,
  } = props;

  const [showModal, setShowModal] = useState(false);
  const [showDropDown, setShowDropDown] = useState(false);
  const [showDropTop, setShowDropTop] = useState(false);
  const [multiValues, setMultiValues] = useState([]);

  const topRef = useRef(null);
  const downRef = useRef(null);

  useEffect(() => {
    // subscribe event
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape, false);
    return () => {
      // unsubscribe event
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape, false);
    };
  }, [multiValues]);

  const handleEscape = (e) => {
    if (e.keyCode === 27) {
      onChangeMulti(multiValues);
      setShowDropTop(false);
      setShowDropDown(false);
    }
  };

  const handleClickOutside = (e) => {
    if (isNil(e)) {
      setShowDropTop(false);
      setShowDropDown(false);
      return;
    }
    if (isNil(topRef.current) && isNil(downRef.current)) {
      return;
    }
    if (!isNil(topRef.current) && !topRef.current.contains(e.target)) {
      onChangeMulti(multiValues);
      setShowDropTop(false);
    }
    if (!isNil(downRef.current) && !downRef.current.contains(e.target)) {
      onChangeMulti(multiValues);
      setShowDropDown(false);
    }
  };

  const openSelect = () => {
    const modalSizes = ["md_horizontal", "sm_vertical", "xs_vertical"];
    if (contains(size, modalSizes)) {
      setShowModal(true);
    } else {
      const element = document.getElementById(`main-field-${name}`);
      // const space = window.innerHeight - element.offsetTop + element.offsetHeight;
      const space = window.innerHeight - element.getBoundingClientRect().top;
      if (space >= 400) {
        setShowDropDown(true);
      } else {
        setShowDropTop(true);
      }
    }
  };

  const getModalStyle = () => {
    switch (size) {
      case "xs_vertical":
        return xs;
      case "sm_vertical":
        return sm;
      default:
        return md;
    }
  };

  const onChangeValues = (inputValue) => {
    setShowDropDown(false);
    setShowDropTop(false);
    setShowModal(false);

    if (isMulti) {
      onChangeMulti(inputValue);
    } else {
      const newValue = contains(inputValue, defaultTo([], value))
        ? ""
        : [inputValue];
      onChange(newValue);
    }
  };

  const getBox = (isModal) => {
    return (
      <OptionsBox
        isMulti={isMulti}
        options={options}
        onChange={(value) => onChangeValues(value)}
        locale={locale}
        multiValues={multiValues}
        setMultiValues={(value) => setMultiValues(value)}
        isModal={isModal}
      />
    );
  };

  const getValueToShow = () => {
    if (value && length(value) === 1) {
      // return value.toString();
      return find(propEq("value", value[0]))(options).label;
    }
    const filteredOptions = filter(
      (option) => contains(option.value, value),
      options
    );
    return join(
      ", ",
      map((v) => v.label, filteredOptions)
    );
  };

  return (
    <Fragment>
      <div
        id={`main-field-${name}`}
        className="select-field-combo-input__main-container"
        style={{ display: show && !isEmpty(options) ? "inherit" : "none" }}
      >
        {showDropTop && (
          <div className="select-field-combo-input__droptop" ref={topRef}>
            {getBox(false)}
          </div>
        )}
        <div className="select-field__labelfield">{ReactHtmlParser(name)}</div>
        <div
          className={`select-field-combo-input__main-field${
            isEmpty(value) ? "--without-value" : ""
          }`}
          onClick={() => openSelect()}
        >
          {exists(options) &&
          exists(value) &&
          includes(
            is(Array, value) && !isEmpty(value) ? value[0].toString() : value,
            map((o) => o.value, options)
          )
            ? getValueToShow()
            : ""}
          <img
            className="select-field-combo-input__main-field-icon"
            src={
              showDropDown || showDropTop || showModal
                ? selectTop
                : selectBottom
            }
            alt={name}
          />
        </div>
        {showDropDown && (
          <div className="select-field-combo-input__dropdown" ref={downRef}>
            {getBox(false)}
          </div>
        )}
      </div>
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        style={getModalStyle()}
        ariaHideApp={false}
      >
        {getBox(true)}
      </Modal>
      <div
        className="field-creator__not-available"
        style={{
          display:
            show && isEmpty(options) && field === "time" ? "inherit" : "none",
        }}
      >
        {translate("field.time.notAvailable", locale)}
      </div>
    </Fragment>
  );
};

SelectFieldComboInput.propTypes = {
  name: PropTypes.string,
  isMulti: PropTypes.bool,
  options: PropTypes.array,
  onChange: PropTypes.func,
  onChangeMulti: PropTypes.func,
  size: PropTypes.string,
  locale: PropTypes.string,
  show: PropTypes.bool,
  value: PropTypes.any,
  field: PropTypes.string,
};

export default SelectFieldComboInput;
